import { RelationOption } from '@components/EntityDrawers/drawers/Relationship/constants/types';
import { ISelectOption } from '@constants/entities/ui';
import { transformArrayToOptions } from '@utils/helpers';

export const formatOptions = (prentOptions: RelationOption[]) => {
  return transformArrayToOptions(prentOptions, {
    label: 'name',
    value: 'id',
  });
};

export const formatValues = (values: string[], options: ISelectOption[]) => {
  return values.reduce<Array<ISelectOption>>((acc, value) => {
    const option = options.find((opt) => opt.value === value);
    if (option) {
      acc.push({ value: option.value, label: option.label });
    }
    return acc;
  }, []);
};
